import { notifyError } from '../components/Messages/Notification';
import {
  AccountContactServiceClient,
  ListAccountContactRequest,
} from '../proto/accountpb/accountcontact_grpc_web_pb';
import { auth } from '../lib/auth/Auth';
import { Pagination } from '../proto/utilspb/pagination_pb';

const service = new AccountContactServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });

export async function listAccountContact(param, paging) {
  return new Promise((resolve, reject) => {
    const req = new ListAccountContactRequest();
    req.setAccountId(param.accountId);
    req.setStatus(param.status);

    if (paging) {
      let pg = new Pagination();
      pg.setPageNo(paging.pageNo);
      pg.setPageSize(paging.rowsPerPage);
      pg.setSortName(paging.sortName);
      pg.setSortDirection(paging.sortDirection);
      pg.setFilterNamesList(paging.filterNames);
      pg.setFilterValuesList(paging.filterValues);
      req.setPagination(pg);
    }

    service.listAccountContact(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
